import { useEffect, useState } from "react";
import "./Popups.css";
import { useRef } from "react";

function Popups(props) {
    const imageNames = [
        'ComputerVirus.png',
        'HOTCOUGARS.png',
        'POKER.png',
        'SingleMen.png'
    ];
    const GAME_LENGTH_SECONDS = 90;

    const [ popupDefinitions, setPopupDefinitions ] = useState([]);
    const [ popupsClosed, setPopupsClosed ] = useState(0);

    const [ gameStartTime, setGameStartTime ] = useState(new Date());
    const [ secondsRemaining, setSecondsRemaining ] = useState(GAME_LENGTH_SECONDS);
    const [ gameRunning, setGameRunning ] = useState(false);
    const [ popupTimeouts, setPopupTimeouts ] = useState([]);

    const [gameInterval, setGameInterval] = useState(null);
    const [imageSizes, setImageSizes] = useState([]);
    //Mirror game display to host
    const MirrorConnection = props.MirrorConnection;
    const observerRef = useRef(null);
    const player= props.player
    document.body.style.backgroundColor = "black";

    //   const SocketConnection = props.SocketConnection;
    const getImagePath = imageName => {
        // Grab image path.
        return `${process.env.PUBLIC_URL}/images/minigames/popups/${imageName}`;
    };

    const getImageSize = (imgSrc) => {
        return new Promise((resolve) => {
        const img = new Image(); 
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.src = imgSrc;
     });
    } 

    // Function to load all images and store their dimensions
    const loadAllImageSizes = async () => {
    
        const imagePaths = imageNames.map(getImagePath);
        const sizePromises = imagePaths.map((path) => getImageSize(path));
        const sizes = await Promise.all(sizePromises);
        setImageSizes(sizes);
       
    };

    useEffect(() => {
        loadAllImageSizes();
    }, []);

    useEffect(() => {
        // Just for debugging.
        console.log("image sizes In use Effect", imageSizes);
    }, [imageSizes]);

    const generatePopupDefinitions = () => {
        const minWindowHeight = 40;
        const maxWindowHeight = 90;
        const minWindowWidth = 30;
        const maxWindowWidth = 80;
        const minDelay = 300;
        const maxDelay = 700;

        const results = [];

        // Ensure that we have the image sizes loaded before generating popups
        if (imageSizes.length === 0) {
            console.error('No image sizes loaded yet!');
            return results;
        }

        for (var i = 0; i < 1000; i++) {

            // Select a random image
            const randomIndex = Math.floor(Math.random() * imageNames.length);
            const imageName = imageNames[randomIndex];
            const imagePath = getImagePath(imageName);

            // Select the corresponding image size
            const imageSize = imageSizes[randomIndex]; // assuming the indexes align with imageNames

            // Determine aspect ratio
            const aspectRatio = imageSize.width / imageSize.height;

            // Set the height of the popup and calculate the width based on the aspect ratio
            let h = Math.floor(Math.random() * (maxWindowHeight - minWindowHeight + 1) + minWindowHeight);
            let w = Math.floor(h * aspectRatio);

            // Ensure the width is within the game window's constraints
            if (w < minWindowWidth) {
                w = minWindowWidth;
                h = Math.floor(w / aspectRatio);  // Adjust height based on the minimum width
            }
            if (w > maxWindowWidth) {
                w = maxWindowWidth;
                h = Math.floor(w / aspectRatio);  // Adjust height based on the maximum width
            }

            let maxTop = 100 - h;
            let maxLeft = 100 - w;
            let delay = Math.floor(Math.random() * (maxDelay - minDelay + 1) + minDelay);

            results.push({
                top: Math.ceil(Math.random() * maxTop),
                left: Math.ceil(Math.random() * maxLeft),
                height: h,
                width: w,
                delay: delay,
                id: player + '-popup-windows-' + i,
                src: imagePath,
            });
        }
        return results;
    };

    const closePopup = (event, definitions) => {
        event.preventDefault();
        if (gameRunning) {
            setPopupDefinitions(popupDefinitions.filter(d => d !== definitions));
            setPopupsClosed(popupsClosed + 1);
        }
    };

    const openPopup = (definitions) => {
        setPopupDefinitions(prevState => [...prevState, definitions]);
    };


     useEffect(() => {
        if (gameRunning && imageSizes.length > 0) {
            const defs = generatePopupDefinitions();
            let totalDelay = 0;
            defs.forEach((def) => {
                totalDelay += def.delay;
                let t = setTimeout(() => {
                    openPopup(def);
                }, totalDelay);
                setPopupTimeouts(prevState => [...prevState, t]);
            });
        } else {
            popupTimeouts.forEach((t) => clearTimeout(t));
            setPopupTimeouts([]);
        }

        // Start the game timer
        if (gameRunning) {
            setGameStartTime(new Date());
            const interval = setInterval(() => {
                let s = GAME_LENGTH_SECONDS - Math.floor((new Date() - gameStartTime) / 1000);
                if (s >= 0) {
                    setSecondsRemaining(s);
                } else {
                    clearInterval(interval);
                    setGameRunning(false);
                }
            }, 1000);
            setGameInterval(interval);
        }

        // Clean up on unmount
        return () => {
            clearInterval(gameInterval);
            popupTimeouts.forEach(clearTimeout);
        };
    }, [gameRunning, imageSizes]); // Now depending on imageSizes

    useEffect(() => {
        setGameRunning(true);
        // setGameStartTime(new Date());


        // setGameInterval(setInterval(() => {
        //     let s = GAME_LENGTH_SECONDS - Math.floor((new Date() - gameStartTime) / 1000);
        //     if (s > -1) {
        //         setSecondsRemaining(s);
        //     } else {
        //         clearInterval(gameInterval);
        //         setGameRunning(false);
        //         setGameInterval(null);
        //     }
        // }, 1000));

    }, []);
    // Check mutation on child of content-to-mirror div
    useEffect(() => {
        const handleContentChange = (mutationsList) => {
            console.log(mutationsList)
            if (mutationsList[0].removedNodes[0] != undefined) {
                if ( document.getElementById(mutationsList[0].removedNodes[0].id) != undefined ) {
                    const child = {"action": "remove", "id" :  mutationsList[0].removedNodes[0].id  }
                    MirrorConnection._socket.send(JSON.stringify(child));
                }
            }
            if (mutationsList[0].addedNodes[0] != undefined) {
                if (document.getElementById(mutationsList[0].addedNodes[0].id) != undefined) {
                    const child = {"action": "add", "id":  mutationsList[0].addedNodes[0].id  ,"content" :  document.getElementById(mutationsList[0].addedNodes[0].id).outerHTML}
                    MirrorConnection._socket.send(JSON.stringify(child));
                }
            }
            // const score = '<div class="livescore">' + document.getElementById('score').innerHTML + '</div>';
            MirrorConnection._socket.send(JSON.stringify({"action": "score", "content": document.getElementById('score').innerHTML})); 
        };
        
        const observer = new MutationObserver(handleContentChange);
        const targetNode = document.getElementById('content-to-mirror');
        if (targetNode) {
          observer.observe(targetNode, { childList: true, subtree: true });
          observerRef.current = observer;
        }
        return () => {
          if (observerRef.current) {
            observerRef.current.disconnect();
          }
        };
      }, []);    

    const popupElement = (definitions) => {
        // width: 640px;
        // height: 100px;
        // top: 20px;
        // left: 250px;
        const title = 'Internet Exploder';
        return (
            <div id={definitions.id} className="popupwindow" style={{
                width: `${definitions.width}%`,
                height: `${definitions.height}%`,
                top: `${definitions.top}%`,
                left: `${definitions.left}%`
            }}>
                <h2><div className="text"><span>{title}</span></div> <a href="#" className="close" onClick={(e) => { closePopup(e, definitions)}}>Close</a></h2>
                <div className="content">
                    <img src={definitions.src} alt="Popup Content" style={{ maxWidth: '100%', maxHeight: '100%' }} />

                </div>
            </div>
        );
    };

    return (
        <div className="container">
            <div id="score" class="score">
                <p>Time Remaining: {secondsRemaining > -1 ? secondsRemaining : 0}</p>
                <p>Closed: {popupsClosed}</p>
            </div>
            <div id="content-to-mirror" className="windows">
                {popupDefinitions.map(def => popupElement(def))}
            </div>
            <div id="testing">
            </div>
        </div>
    );
  }
  
  export default Popups;